import { Navigate } from "react-router-dom";
import { URLS } from "../../utils/constants";

const LoginProtectedRoute = ({ children }) => {
  const auth = localStorage.getItem("token");
  const roles = localStorage.getItem("roles")
    ? JSON.parse(localStorage.getItem("roles"))
    : [];

  const postLoginRedirect = localStorage.getItem("postLoginRedirect");
  if (auth && postLoginRedirect) {
    localStorage.removeItem("postLoginRedirect");
    return <Navigate to={postLoginRedirect} replace />;
  }

  return auth ? (
    <Navigate
      to={
        roles.includes("USER")
          ? URLS.USERS
          : roles.includes("ADMIN")
          ? URLS.ADMIN
          : URLS.TRAINERS_DASHBOARD
      }
    />
  ) : (
    children
  );
};

export default LoginProtectedRoute;
